import React from "react";
import FormInputWrapper from "../form-input-wrapper/";
import { TextAreaProps } from "../../utils/types/props.textarea";
import { Textarea } from "@chakra-ui/react";

const FormTextArea = ({
  label,
  placeholder,
  isRequired,
  ref,
  value,
  errorMessage,
  onChange,
}: TextAreaProps) => {
  return (
    <FormInputWrapper
      label={label}
      isRequired={isRequired}
      errorMessage={errorMessage}
    >
      <Textarea
        placeholder={placeholder}
        size="sm"
        value={value}
        onChange={onChange}
        id={label}
        name={label}
      />
    </FormInputWrapper>
  );
};

export default FormTextArea;
